import { useEffect, useState } from "react";
import Filter from "./Filter";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { FullReservation, GroupSale, ReservationPaymentList } from "../../../types/common.types";
import List from "./List";
import jsPDF from "jspdf";
import { format } from "date-fns";
import formatNumberToString from "../../../utils/formatNumber";

interface Accounting {
    total_price: number;
    total_tickets: number;
    total_tarjeta: number;
    total_efectivo: number;
    total_transferencia: number;
    total_deuda: number;
    total_wise: number;
}

export default function Sales() {

    const { currentDay, endDay, viewPaymentsData } = useAdmin()
    const [sellerId, setSellerId] = useState<string>("")
    const [sales, setSales] = useState<ReservationPaymentList[]>([])

    const [account, setAccount] = useState<Accounting>({} as Accounting)

    useEffect(() => {
        async function fetchSales() {
            try {
                if (!currentDay || !sellerId) return
                const data = await (await AdminService.listSalesByDay(currentDay, sellerId, endDay)).data
                setSales(data.reservations)
                setAccount(data.account)
                console.log(data);
            } catch (error) {
                console.log(error);
                
            }
            
        }
        fetchSales()
    }
    , [currentDay, endDay, sellerId, viewPaymentsData])

    
    return (
        <>
            <Filter setSelectedSeller={setSellerId}/>
            <div className="pdf-print">
                {/* <button
                    // onClick={printSales}
                    className="btn btn-primary"
                    style={{marginBottom: '20px', backgroundColor: '#4087f1', color: '#fff', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer'}}
                >
                    Print
                </button> */}
            </div>
            <div className="accounting" style={{display: 'flex', textAlign: 'center', flexWrap: 'wrap', gap: '10px'}}>
                {Object.entries(account).map(([key, value]) => (
                    <div key={key} className="accounting-item">
                    <span>
                        {key.split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}:
                    </span>
                    <span>
                        {
                        formatNumberToString(Number(value))
                        }
                    </span>
                    </div>
                ))}
            </div>
            <List data={sales}/>
        </>
    )
}